<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Campaigns</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Campaigns
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Campaigns</h4>
                </div>

                <div class="card-body">
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allCampaigns"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>

                            <div v-else-if="props.column.field === 'reoccurring'">
                                <template v-if="props.row.reoccurring">
                                    <span class="badge badge-glow badge-success">Yes</span>
                                </template>
                                <template v-else>
                                    <span class="badge badge-glow badge-danger">No</span>
                                </template>
                            </div>

                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <Link :href="route('admin.campaigns.campaign-history', props.row.id)" class="dropdown-item">
                                    <i class="feather icon-list"></i>
                                    History
                                </Link>
                                <a
                                    v-if="!props.row.reoccurring"
                                    href="#"
                                    class="dropdown-item"
                                    @click.prevent="showResendAlert(props.row.id)"
                                >
                                    <i class="feather icon-message-square"></i>
                                    Resend
                                </a>
                                <Link
                                    v-if="props.row.reoccurring"
                                    :href="route('admin.campaigns.edit', props.row.id)"
                                    class="dropdown-item"
                                >
                                    <i class="feather icon-edit"></i>
                                    Edit
                                </Link>
                                <a
                                    v-if="props.row.reoccurring"
                                    href="#"
                                    class="dropdown-item text-danger"
                                    @click.prevent="showAlert(props.row.id)"
                                >
                                    <i class="feather icon-trash-2"></i>
                                    Delete
                                </a>
                            </table-row-actions>
                            <span v-else-if="props.column.field === 'channels'">
                              <span v-for="key in props.row.channels" :key="key" class="badge bg-primary mx-1">
                                {{ key }}
                              </span>
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";

export default {
    metaInfo: {title: 'Campaigns'},
    props: ['campaigns'],
    layout: Layout,
    components: {
        Link,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
    ],
    data: () => ({

        filter: {},
        isLoadingFilter: false,
        allCampaigns: [],
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10
        },

        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },

        sortingOptions: {
            enabled: false,
        },

        columns: [
            {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Title', field: 'title', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Description', field: 'description', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Reoccurring', field: 'reoccurring', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Start Date', field: 'start_date', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'End Date', field: 'end_date', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Added By', field: 'added_by', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Channels', field: 'channels', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
    }),

    mounted() {
        this.allCampaigns = this.campaigns.data;
        this.totalRecords = this.campaigns.total
    },

    methods: {
        async paginatedData() {
            try {
                let routeName = 'admin.campaigns.index';

                let response = await axios.get(route(routeName), {
                    params: {
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalRecords = response.data.total;
                this.paginationOptions.perPage = response.data.per_page;
                this.serverParams.perPage = response.data.per_page;
                this.paginationOptions.setCurrentPage = response.data.page;
                this.allCampaigns = response.data.data
            } catch (e) {
                console.log(e);
            }
        },
        async deleteCampaign(id) {
            this.$inertia.delete(route('admin.campaigns.delete', id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.paginatedData();
                }
            })
        },
        async resendCampaign(id) {
            this.$inertia.post(route('admin.campaigns.resend-campaign', id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.paginatedData();
                }
            })
        },
        async showAlert(campaignId) {
            const details = {
                title: "Are you sure you want to delete this campaign?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? await this.deleteCampaign(campaignId) : "";
        },
        async showResendAlert(campaignId) {
            const details = {
                title: "Are you sure you want to resend this campaign?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text,  true, "#3085d6", "#d33", "Yes, resend it!") ? await this.resendCampaign(campaignId) : "";
        },
    }
}
</script>
